import React from 'react';
import { useTranslation } from 'react-i18next';
import './FooterLinkPages.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="footer-link-page">
      <h1>{t('privacy.title')}</h1>
      <p className="last-updated">{t('privacy.lastUpdated')}</p>

      <section>
        <h2>{t('privacy.introTitle')}</h2>
        <p>{t('privacy.intro')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataCollectionTitle')}</h2>
        <p>{t('privacy.dataCollection')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataUsageTitle')}</h2>
        <p>{t('privacy.dataUsage')}</p>
      </section>

      <section>
        <h2>{t('privacy.dataStorageTitle')}</h2>
        <p>{t('privacy.dataStorage')}</p>
      </section>

      <section>
        <h2>{t('privacy.thirdPartiesTitle')}</h2>
        <p>{t('privacy.thirdParties')}</p>
      </section>

      <section>
        <h2>{t('privacy.consentTitle')}</h2>
        <p>{t('privacy.consent')}</p>
      </section>

      <section>
        <h2>{t('privacy.childrenTitle')}</h2>
        <p>{t('privacy.children')}</p>
      </section>

      <section>
        <h2>{t('privacy.changesTitle')}</h2>
        <p>{t('privacy.changes')}</p>
      </section>

      <section>
        <h2>{t('privacy.contactTitle')}</h2>
        <p>{t('privacy.contact')}</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
